import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurModeMastService {

  private apiBaseUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  WBPurModeMastSave(Data:any):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl+'/admin/PurModeMast/WBPurModeMastSave',Data);
  }

  WBPurModeMastFill(Data:any):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl+'/admin/PurModeMast/WBPurModeMastFill',Data);
  }

  WBPurModeMastDelete(Data:any):Observable<any>{
    return this.http.post<any>(this.apiBaseUrl+'/admin/PurModeMast/WBPurModeMastDelete',Data);
  }
}
